import { render, staticRenderFns } from "./HiboProgress.vue?vue&type=template&id=9bf4726a&scoped=true&"
import script from "./HiboProgress.vue?vue&type=script&lang=ts&"
export * from "./HiboProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf4726a",
  null
  
)

export default component.exports